// extracted by mini-css-extract-plugin
export default {"pictureBlock":"Picture_pictureBlock__Umpgb","media":"Picture_media__5SCUd","whiteBg":"Picture_whiteBg__hCM+R"};